$ ->
  # See ReferralAttributionConcern
  # This ensures that a tracking code such as #src.[campaign] is stored in the relevant cookies
  #  by issuing an XHR request to the Rails app with the campaign ID
  hash = window.location.hash.substr(1)
  if hash.indexOf('src.') > -1
    referralCode = hash.split('.')[1]
    if referralCode
      $.get("/noop?src=#{encodeURI(hash.split('.')[1])}")
